<template>
  <section class="news-payment">
    <header class="title-header">
      <span class="back-btn" @click="goBack()">
        <img src="@/assets/images/ic_back.svg" alt />
      </span>
      <h1 class="header-title">Payment</h1>
    </header>
    <div class="fee">
      <h2>Registration Fees</h2>
      <span>Rs {{$route.query.paymentFee}}</span>
    </div>
    <div class="message">
      <p>Partime91 पे रजिस्टर करने के लिए आपको 500 का</p>
      <p>भुकतान करना पड़ेगा</p>
    </div>
    <div class="payment-option">
      <h2>पेमेंट करे</h2>
      <ul style="margin-top: 8px;">
        <li class="custom-checkbox">
          <div @click="selectMode('PAYTM')">
            <span class="check-mark" :class="{'active' :!activePaymentMode }"></span>
            <span class="name">Paytm Payment</span>
            <span class="card-img">
              <img src="../assets/images/paytm.svg" alt />
            </span>
          </div>
        </li>
        <li class="custom-checkbox">
          <div @click="selectMode('NETBANKING')">
            <span class="check-mark" :class="{'active' :activePaymentMode }"></span>
            <span class="name">Debit card / Netbanking</span>
            <span class="card-img">
              <img src="../assets/images/credit-card.svg" alt />
            </span>
          </div>
        </li>
      </ul>
    </div>
    <span class="bottom_btn" @click="paymentConfirm()">Rs {{$route.query.paymentFee}} का भुकतान करे</span>
    <CustomToaster :dataValue="toasterData" v-if="isValidDetail" />
    <div class="loader" v-if="loading">
      <img src="../assets/images/loader.gif" alt="loader" />
    </div>
  </section>
</template>

<script>
import ApiCaller from "../utils/apicaller";
import constant from "../utils/constant";
import { SessionHelper, X_AUTH_ID } from "../utils/session";
import CustomToaster from "../components/Common/CustomToaster";

export default {
  name: "PaymentOption",
  components: {},
  props: {
    getformData: {
      type: Object
    },
    isPaymentOption: {
      type: Boolean
    }
  },
  data() {
    return {
      isValidDetail: false,
      toasterData: {},
      loading: false,
      activePaymentMode: false
    };
  },
  methods: {    
    goBack() {
      // this.isPaymentOption = !this.isPaymentOption;
      this.$emit("closePayment", this.isPaymentOption);
    },
    selectMode(value) {
      if (value === "NETBANKING") {
        this.activePaymentMode = !this.activePaymentMode;
      } else {
        this.activePaymentMode = !this.activePaymentMode;
      }
    },
    payNow(){
       if (this.activePaymentMode) {
        window.location.href = `${
          constant.BASE_API_URL
        }payment/gateway/?gateway_amount=${
          this.$route.query.paymentFee
        }&Task-Id=${
          this.$route.query.task_id
        }&PO=Card&x_auth_id=${SessionHelper.getCookie(X_AUTH_ID)}`;
        // this.loading = false;
      } else {
        window.location.href = `${
          constant.BASE_API_URL
        }payment/gateway/?gateway_amount=${
          this.$route.query.paymentFee
        }&Task-Id=${
          this.$route.query.task_id
        }&x_auth_id=${SessionHelper.getCookie(X_AUTH_ID)}`;
        // this.loading = false;
      }
    },
    paymentConfirm() {
      //  this.$router.push('payment-confirmation')
      this.loading = true;
      const obj = this.getformData;
      ApiCaller(
        constant.BASE_API_URL,
        "tasks/localnews_registeration/",
        "post",
        obj
      )
        .then(data => {
          if (data.success) {
            if (this.activePaymentMode) {
              window.location.href = `${
                constant.BASE_API_URL 
              }payment/gateway/?gateway_amount=${
                this.$route.query.paymentFee
              }&Task-Id=${
                this.$route.query.allTaskIndex
              }&PO=Card&x_auth_id=${SessionHelper.getCookie(X_AUTH_ID)}`;
              // this.loading = false;
            } else {
              window.location.href = `${
                constant.BASE_API_URL
              }payment/gateway/?gateway_amount=${
                this.$route.query.paymentFee
              }&Task-Id=${
                this.$route.query.allTaskIndex
              }&x_auth_id=${SessionHelper.getCookie(X_AUTH_ID)}`;
              // this.loading = false;
            }
          }
        })
        .catch(err => {
          this.loading = false;
          console.log(err);
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.custom-checkbox {
  background: none;
}
.news-payment {
  padding-top: 0;
}
</style>